export default "__VITE_ASSET__DdR6Ld9T__"